<template>
    <el-dialog
            class="selfModal"
            title="修改部门"
            :close-on-click-modal="false"
            :visible="editData.state"
            width="480px"
            :modal="false"
            @close="closeModal()"
    >
        <div  style="padding-right: 20px">
            <el-form :model="formValidate" :rules="ruleValidate" ref="ruleForm" label-width="100px"
                     class="demo-ruleForm">
                <!-- <el-form-item label="上级部门">
                    <span style="padding-left: 15px">{{searchParentName(formValidate.parentId)}}</span>
                </el-form-item> -->
                <el-form-item label="上级部门" prop="deptName">
                    <el-col :span="20">
                        <el-input disabled :value="searchParentName(formValidate.parentId)"></el-input>
                    </el-col>
                    <el-col :span="4" style="display: flex;justify-content: flex-end">
                        <el-button @click="changeUserDept" icon="el-icon-menu"></el-button>
                    </el-col>
                </el-form-item>
                <el-form-item label="部门名称" prop="name">
                    <el-input v-model="formValidate.name"></el-input>
                </el-form-item>
                <el-form-item label="部门编码" prop="deptCode">
                    <el-input v-model="formValidate.deptCode" ></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input-number v-model.number="formValidate.sort" controls-position="right" :min="1" step-strictly></el-input-number>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm('ruleForm')" :disabled="subDisabled">确 认</el-button>
            <el-button @click="resetForm('ruleForm')">重 置</el-button>

        </span>

        <el-dialog
            class="selfModal selfModal_youBtn"
            :close-on-click-modal="false"
            :visible.sync="chooseDepartment.state"
            width="480px"
            title="部门选择"
            :modal="false"
        >
            <div class="modaltree">
                <treeMenu
                    ref="treeMenu"
                    initId="0"
                    :showArrow="false"
                    :showShadow="false"
                    :isEdit="false"
                    loadStyle="staticLoad"
                    @nodeClick="nodeIdModal"
                    :showBox="false"
                ></treeMenu>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="depTreeBtn('1')">确 定</el-button>
            </span>
        </el-dialog>
    </el-dialog>
</template>

<script>
    import {updateDept} from '@/api/admin/dept';
    import treeMenu from '@/components/treeMenu/index.vue'

    export default {
        props: {
            editData: {
                type: Object,
                required: true
            }
        },
        components: {treeMenu},
        data() {
            return {
                subDisabled: false,
                ruleForm: {},
                orgLevel: [
                    {value: '1', label: '校级'},
                    {value: '2', label: '院系'},
                    {value: '3', label: '专业'},
                    {value: '4', label: '班级'}
                ],
                teachUnit: [
                    {value: '1', label: '是'},
                    {value: '0', label: '否'}
                ],
                formValidate: {
                    deptId: '',
                    // deptCode: '',
                    // organLevel: '',
                    name: '',
                    // organType: '',
                    sort: '',
                    // joinHie: '',
                    parentId: '',
                    deptCode: '',
                    sort: '',
                }, // 表单数据绑定
                ruleValidate: {
                    name: [
                        {required: true, message: '部门名称不能为空', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
                    ],
                    deptCode: [
                        {required: true, message: '部门编码不能为空', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
                    ],
                }, // 表单验证

                chooseDepartment: {
                    state: false,
                    data: {},
                    showBox: false
                },
            };
        },
        computed: {},
        methods: {
            changeUserDept() {
                this.chooseDepartment.data = {};
                this.chooseDepartment.chooseBox = false;
                this.chooseDepartment.state = true;
            },
            nodeIdModal(tree) {
                console.log(tree)
                this.chooseDepartment.data = tree
            },
            depTreeBtn() {
                this.formValidate.parentId = this.chooseDepartment.data.id;
                // this.formValidate.deptName = this.chooseDepartment.data.name;
                this.chooseDepartment.state = false
            },
            /**
             * @description: 上级部门
             * @param:{pagesize, pageindex, deptId}
             * @return:
             */
            searchParentName(parentId) {
                let parentName;
                let searchParentName = function (searchdata, searchpid) {
                    searchdata.forEach(e => {
                        if (e.id == searchpid) {
                            parentName = e.name;
                            return;
                        } else {
                            if (e.children.length > 0) {
                                searchParentName(e.children, searchpid);
                            }
                        }
                    });
                };
                console.log(this.$store.getters.chooseDept)
                searchParentName(this.$store.getters.chooseDept, parentId);
                return parentName;
            },
            showEditData() {
                // this.formValidate.deptCode = this.editData.data.deptCode;
                this.formValidate.name = this.editData.data.name;
                // this.formValidate.organLevel = this.editData.data.organLevel.toString();
                // this.formValidate.organType = this.editData.data.organType.toString();
                this.formValidate.sort = this.editData.data.sort;
                this.formValidate.parentId = this.editData.data.parentId;
                // this.formValidate.joinHie = parseInt(this.editData.data.joinHie);
                this.formValidate.deptId = this.editData.data.deptId
                this.formValidate.deptCode = this.editData.data.deptCode
                this.formValidate.sort = this.editData.data.sort
            },
            closeModal() {
                this.$emit("closeEdit", {state: false});
                this.editData.state = false;
                this.resetForm('ruleForm')
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.subDisabled = true;
                        updateDept(this.formValidate).then(res => {
                            this.subDisabled = false;
                            if (res.data.code == 0) {
                                this.$store.dispatch("getDeptTree").then((data) => {
                                    this.$store.commit("SET_CHOOSE_DEPT",data.data.data)
                                });
                                this.closeModal()
                            } else {
                                this.$alert(res.data.msg, '提示', {
                                    confirmButtonText: '确定',
                                    type: 'warning'
                                });
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                // this.formValidate.name = ''
                // this.formValidate.deptCode = ''
                this.formValidate.deptCode = this.editData.data.deptCode;
                this.formValidate.sort = this.editData.data.sort;
                this.formValidate.name = this.editData.data.name;
                // this.formValidate.organLevel = this.editData.data.organLevel.toString();
                // this.formValidate.organType = this.editData.data.organType.toString();
                this.formValidate.sort = this.editData.data.sort;
                this.formValidate.parentId = this.editData.data.parentId;
                // this.formValidate.joinHie = parseInt(this.editData.data.joinHie);
                this.formValidate.deptId = this.editData.data.deptId
                setTimeout(()=>{

                },200)
            }
        }
    }
</script>

<style scoped>

</style>
